module.exports = __webpack_public_path__ + "static/media/report_sinister.c3c0b541.svg";